<template>
  <IconRouterLink
    v-if="item.to && isInternalRoute"
    :to="item.to"
    :icon="item.icon"
    @clicked="$emit('clicked')"
    :disabled="item.disabled"
    :loading="item.loading"
    :tooltip="item.name"
    :testId="item.icon?.testId || `${testId}-${item.name.toLowerCase().replaceAll(' ', '-')}-link`"
  />
  <IconLink
    v-else-if="item.to && !isInternalRoute"
    :href="item.to.name"
    :icon="item.icon"
    @clicked="$emit('clicked')"
    :disabled="item.disabled"
    :loading="item.loading"
    :tooltip="item.name"
    :target="item.to.target"
    :testId="item.icon?.testId || `${testId}-${item.name.toLowerCase().replaceAll(' ', '-')}-link`"
  />
  <IconButton
    v-else
    @click="itemAction()"
    :icon="item.icon"
    :disabled="item.disabled"
    :loading="item.loading"
    :tooltip="item.name"
    :testId="
      item.icon?.testId || `${testId}-${item.name.toLowerCase().replaceAll(' ', '-')}-button`
    "
  />
</template>

<script>
import { computed, ref } from "vue";
import IconButton from "@/components/display/IconButton.vue";
import IconLink from "@/components/display/IconLink.vue";
import IconRouterLink from "@/components/display/IconRouterLink.vue";
import Router from "@/router";

export default {
  name: "NavLinkIcon",
  components: {
    IconButton,
    IconLink,
    IconRouterLink,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    testId: {
      type: String,
    },
    linkTarget: {
      type: String,
      default: "_self",
      validator: (val) => ["_blank", "_self"].includes(val),
    },
  },
  emits: ["clicked"],
  setup: (props, { emit }) => {
    const active = ref(false);

    const blur = () => (active.value = false);

    const focus = () => (active.value = true);

    const isInternalRoute = computed(() =>
      props.item?.to ? Router.hasRoute(props.item.to.name) : false
    );

    const itemAction = () => {
      if (props.item.action) {
        props.item.action();
        emit("clicked");
      }
    };

    return {
      blur,
      focus,
      isInternalRoute,
      itemAction,
    };
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  > * {
    pointer-events: none;
  }
}

.dropdown-item {
  @apply tw-inline-flex tw-bg-transparent tw-text-current;
  padding: 0;
  text-decoration: none;
}
</style>
